'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TripViewModel=require('../../../../dist-es6/client/viewModels/tripViewModel');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

ScenarioController=(_class=function(_BaseController){_inherits(ScenarioController,_BaseController);_createClass(ScenarioController,null,[{key:'$inject',get:function()
{
return['$state','$timeout','breadcrumbsService','waypointViewModelService','uncaughtErrorHandler','uiCommandFactory','tripPlanningService'];
}}]);

function ScenarioController($state,$timeout,breadcrumbsService,waypointViewModelService,uncaughtErrorHandler,uiCommandFactory,tripPlanningService){_classCallCheck(this,ScenarioController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler));

_this._isInitialized=!1;
_this._$timeout=$timeout;

let{
personInfo:personInfo,
originalInputs:originalInputs,
fatigueThreshold:fatigueThreshold,
schedule:schedule,
route:route,
queryInterval:queryInterval}=
$state.params;

if(!_.allExist(personInfo,originalInputs,fatigueThreshold,schedule,route,queryInterval)){
$state.go("fdc.features.emiratesDashboard");
return _possibleConstructorReturn(_this);
}

_this._$state=$state;
_this._waypointViewModelService=waypointViewModelService;
_this._tripPlanningService=tripPlanningService;
_this._personInfo=personInfo;
_this._fatigueThreshold=fatigueThreshold;
_this._originalInputs=originalInputs;

_this._displayName=_this._personInfo.firstName.concat(' ').concat(_this._personInfo.lastName);

_this._reload({
queryInterval:queryInterval,
route:route,
schedule:schedule});


_this._recalculationErrors=[];
_this._recalculateTripCommand=uiCommandFactory.make(_this._recalculateTrip.bind(_this));

breadcrumbsService.dropCrumb('Scenario');

$timeout(function(){
_this._isInitialized=!0;
});return _this;
}ScenarioController.prototype.


_reload=function _reload(planningResult){var _this2=this;
this._queryInterval=planningResult.queryInterval;
this._route=planningResult.route;
this._schedule=planningResult.schedule;


for(let stop of this._route.stops){
if(!_.exists(stop.location.city)&&stop.location.state==='NJ'&&stop.location.street==='27 Chestertown Road'){
stop.location.city='Sicklerville';
}
}

this._waypointsForDisplay=this._waypointViewModelService.createWaypointViewModelsForRoute(this._route.stops,this._route.statusTransitions,function(wp){
_this2._$timeout(function(){
_this2._currentlyEditedWaypoint=wp;
});
});

let firstStop=_.first(this._route.stops);
let lastStop=_.last(this._route.stops);
this._overallTrip=new TripViewModel({
start:firstStop.duration.start,
end:lastStop.duration.end,
origin:firstStop.location,
destination:lastStop.location});

};ScenarioController.prototype.













































cancelEdits=function cancelEdits(){
if(this._recalculating){
return;
}

if(_.exists(this._currentlyEditedWaypoint)){
this._currentlyEditedWaypoint.edits=null;
}
this._currentlyEditedWaypoint=null;
this._recalculationErrors=[];
};ScenarioController.prototype.


_recalculateTrip=function(){var ref=_asyncToGenerator(function*(){
this._recalculating=!0;
this._recalculationErrors=[];


let inputsForRecalculation=this._originalInputs.map(function(i){return _.clone(i)});
let firstWaypoint=_.first(this.waypointsForDisplay);
let lastWaypoint=_.last(this.waypointsForDisplay);

let inputToUpdate;
let editSource;
switch(this._currentlyEditedWaypoint){
case firstWaypoint:
inputToUpdate=_.first(inputsForRecalculation);
editSource=firstWaypoint;
break;

case lastWaypoint:
inputToUpdate=_.last(inputsForRecalculation);
editSource=lastWaypoint;
break;

default:
console.log('unexpected waypoint edit');
return;}

inputToUpdate.address=editSource.edits.address;
inputToUpdate.displayTime=editSource.edits.displayTime;

let planningResult=yield this._tripPlanningService.plan(this._personInfo.id,inputsForRecalculation);

this._recalculating=!1;

if(_.exists(planningResult.errors)){
this._recalculationErrors=planningResult.errors;
return;
}

this._currentlyEditedWaypoint=null;

this._$state.go('fdc.features.scenario',{
personInfo:this._$state.params.personInfo,
fatigueThreshold:this._$state.params.fatigueThreshold,
originalInputs:inputsForRecalculation,
schedule:planningResult.schedule,
route:planningResult.route,
queryInterval:planningResult.queryInterval});

});function _recalculateTrip(){return ref.apply(this,arguments)}return _recalculateTrip}();_createClass(ScenarioController,[{key:'isInitialized',get:function(){return this._isInitialized}},{key:'displayName',get:function(){return this._displayName}},{key:'fatigueThreshold',get:function(){return this._fatigueThreshold}},{key:'waypointsForDisplay',get:function(){return this._waypointsForDisplay}},{key:'schedule',get:function(){return this._schedule}},{key:'queryInterval',get:function(){return this._queryInterval}},{key:'route',get:function(){return this._route}},{key:'overallTrip',get:function(){return this._overallTrip}},{key:'recalculateTripCommand',get:function(){return this._recalculateTripCommand}},{key:'currentlyEditedWaypoint',get:function(){return this._currentlyEditedWaypoint}},{key:'recalculationErrors',get:function(){return this._recalculationErrors}}]);return ScenarioController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_recalculateTrip',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_recalculateTrip'),_class.prototype)),_class);


module.exports=ScenarioController;
//# sourceMappingURL=scenarioController.js.map
